"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Video = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _common = require("b2b-components/theme/common");
var _classnames = _interopRequireDefault(require("classnames"));
require("./Video.scss");
var Video = function Video(_ref) {
  var className = _ref.className,
    title = _ref.title,
    videoUrl = _ref.videoUrl;
  var url = new URL(videoUrl);
  var rootClassName = (0, _classnames["default"])('cds-Video', className);
  url.searchParams.append('autoplay', '1');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-Video-IframeWrapper"
  }, /*#__PURE__*/_react["default"].createElement("iframe", (0, _extends2["default"])({
    src: videoUrl,
    title: title || '',
    allow: "autoplay",
    frameBorder: "0"
  }, videoUrl.includes(_common.VIDEO_TYPE.vimeo) && {
    allowFullScreen: true,
    mozallowfullscreen: 'true',
    webkitallowfullscreen: 'true'
  }, {
    className: "cds-Video-Iframe"
  }))));
};
exports.Video = Video;